<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-4">Εκτυπώσεις</h1>
      </v-col>
    </v-row>

    <v-row>
      <!-- Sales -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.1')">
        <v-card link :to="{ name: 'report-sales' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Πωλήσεις</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Customer Balance -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.4')">
        <v-card link :to="{ name: 'report-customers-balance' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Υπόλοιπα πελατών</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Sales Averages -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.2')">
        <v-card link :to="{ name: 'report-sales-averages' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Τιμή πώλησης ανά προϊόν</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Sales Per Customer -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.3')">
        <v-card link :to="{ name: 'report-sales-per-customer' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Πωλήσεις (Μ.Ο.) ανά πελάτη</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Sales Per Day -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.4')">
        <v-card link :to="{ name: 'report-sales-per-day' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Πωλήσεις ανά ημέρα</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Order Sums Per Customer -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.5')">
        <v-card link :to="{ name: 'report-order-sums-per-customer' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Παραγγελίες ανά πελάτη</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Order Sums Per Distributor -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.5')">
        <v-card link :to="{ name: 'report-order-sums-per-distributor' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Παραγγελίες ανά διανομέα</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Sales Per Product -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.6')">
        <v-card link :to="{ name: 'report-sales-per-product' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Πωλήσεις ανά κωδικό</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Sales Sums Per Customer -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.7')">
        <v-card link :to="{ name: 'report-sales-sums-per-customer' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Πωλήσεις ανά πελάτη</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Epsilon Bridges (Category) -->
      <template v-if="showGefyresEpsilon">
        <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.8')">
          <v-card link :to="{ name: 'report-export-esoda-epsilon-b' }" height="100%">
            <v-card-text class="text-center">
              <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
              <div class="text-h6">Έσοδα Β' (Epsilon)</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.9')">
          <v-card link :to="{ name: 'report-export-eksoda-epsilon-b' }" height="100%">
            <v-card-text class="text-center">
              <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
              <div class="text-h6">Έξοδα Β' (Epsilon)</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.8')">
          <v-card link :to="{ name: 'report-export-esoda-epsilon-c' }" height="100%">
            <v-card-text class="text-center">
              <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
              <div class="text-h6">Έσοδα Γ' (Epsilon)</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.9')">
          <v-card link :to="{ name: 'report-export-eksoda-epsilon-c' }" height="100%">
            <v-card-text class="text-center">
              <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
              <div class="text-h6">Έξοδα Γ' (Epsilon)</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.10')">
          <v-card link :to="{ name: 'report-export-accounts-epsilon' }" height="100%">
            <v-card-text class="text-center">
              <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
              <div class="text-h6">Συναλλασόμενοι (Epsilon)</div>
            </v-card-text>
          </v-card>
        </v-col>
      </template>

      <!-- Fortoseis Ana Dianomea -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.7')">
        <v-card link :to="{ name: 'report-fortoseis-ana-dianomea' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Φορτώσεις ανα διανομέα</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Order Sums Per Supplier -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.7')">
        <v-card link :to="{ name: 'report-order-sums-per-supplier' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Παραγγελίες ανά προμηθευτή</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Quantity Per Month -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.7')">
        <v-card link :to="{ name: 'report-quantity-per-month' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Πωλήσεις ανά μήνα</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Tziros Per Month -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.8')">
        <v-card link :to="{ name: 'report-tziros-per-month' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Τζίρος ανά μήνα</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Stock Movements -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.8')">
        <v-card link :to="{ name: 'report-stock-movements' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Κινήσεις προϊόντων</div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Purchases Per Supplier -->
      <v-col cols="12" sm="6" md="4" lg="3" v-if="showMenu('7.9')">
        <v-card link :to="{ name: 'report-purchases-per-supplier' }" height="100%">
          <v-card-text class="text-center">
            <v-icon large color="primary" class="mb-2">mdi-cash-register</v-icon>
            <div class="text-h6">Αγορές (Μ.Ο.) ανά προμηθευτή</div>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    showGefyresEpsilon() {
      let user = this.$store.state.currentUser.user
      return user && user.company.show_gefyres_epsilon === true
    }
  },
  methods: {
    showMenu(menuId) {
      let user = this.$store.state.currentUser.user
      if (!user) return false
      
      let userMenuConfig = user.menu_config
      if (userMenuConfig == null) return true
      if ((userMenuConfig?.length > 1) == false) return true

      return (userMenuConfig.indexOf(menuId) >= 0)
    }
  }
}
</script>
